import React from "react";
import { ICellRendererParams } from "ag-grid-community";
import { ProductCollectionCard } from "../../product-collection-tile-view/product-collection-card";
import { IDisplayFields, ISchemaKey } from "helpers/product-collection";
import { IAllocationDimension } from "helpers/allocation-dimension";
import { IGridParamsQueryParam } from "../tool-panels";
import { ICurrency } from "./pinned-row-renderers";
import { ITileSettings } from "components/product-collection/manage-tile-view/types";
import { COLLECTION_ID_FIELD_NAME } from "helpers/server-rollup";
import { memoizedGetNewDimensionFilters } from "../product-collection-grid-view-helper";
import { UnitsEntryType } from "constants/product-collection";
import { TileViewGroupRenderer } from "./tile-view-group-renderer";
import { DimensionsPanelReduxState } from "reducers/dimensions-panel/dimensions-panel";

interface IProps extends ICellRendererParams {
    defaultDateFormat?: string;
}

export interface IProductCollectionTileGridContext {
    collectionId: string;
    brandEntities: any;
    cardViewFields: IDisplayFields;
    formulaFields: IDisplayFields;
    allocationDimensions: IAllocationDimension[];
    gridParams: IGridParamsQueryParam;
    dimensionsPanelApplied: DimensionsPanelReduxState;
    merchantCurrency?: ICurrency;
    tileSettings?: ITileSettings;
    onGetTileSettings?: () => ITileSettings;
    rawItemDisplayProperty?: ISchemaKey[];
    tileViewSize?: string;
    getTileViewSize: () => string;
    onItemInvoked: (id: string, assortmentId?: string) => void;
}

const containerStyles = {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    height: "100%",
};

export const FullWidthCellRenderer: React.FunctionComponent<IProps> = (params): any => {
    const { data, api: gridApi, context, node } = params;

    if (node.group) {
        return <TileViewGroupRenderer {...params} />;
    }
    const tileGridContext: IProductCollectionTileGridContext = context.tileGridContext;
    const dataEntryType: UnitsEntryType = context.dataEntryType;
    const doors = context.doors;
    const allocationDimensions = tileGridContext.allocationDimensions;

    const tileViewSize = tileGridContext.getTileViewSize() ?? tileGridContext.tileViewSize;

    return (
        <div
            style={containerStyles}
            onClick={() =>
                tileGridContext.onItemInvoked(data.id, data.fields?.[COLLECTION_ID_FIELD_NAME]?.string_value)
            }
        >
            <ProductCollectionCard
                collectionId={tileGridContext.collectionId}
                gridApi={gridApi}
                editable={false}
                brandEntities={tileGridContext.brandEntities}
                cardViewFields={tileGridContext.cardViewFields}
                doors={doors}
                formulaFields={tileGridContext.formulaFields}
                allocationDimensions={allocationDimensions}
                gridParams={tileGridContext.gridParams}
                dimensionsPanelApplied={tileGridContext.dimensionsPanelApplied}
                allowDuplicateProduct={false}
                merchantCurrency={tileGridContext.merchantCurrency}
                tileSettings={tileGridContext?.onGetTileSettings() || tileGridContext.tileSettings}
                tileViewSize={tileViewSize}
                data={data}
                isSortable={false}
                dataIndex={params.rowIndex}
                isServerSide={true}
                dimensionFilters={memoizedGetNewDimensionFilters(
                    allocationDimensions,
                    tileGridContext.gridParams,
                    tileGridContext.dimensionsPanelApplied
                )}
                isAverageUnitsMode={dataEntryType === UnitsEntryType.Average}
            />
        </div>
    );
};
